angular.module('cvsApp').service('validateOrderService',['networkService', 'xdrService', 'validateOrderModel', 'configManager','itemCartModel','$rootScope','validation','placeOrderHelperService','cvsAppData','loggerService', 'loggerServiceHelper',
	function (NS, XS, VOM, CM,ICM,$rootScope,VF,POHS,CAD, loggerService, loggerServiceHelper) {

	function validateOrder (){
		this.validateOrderData = function(callBackSuccess){
			//get url
			var tokenId, tokenType;
			// var tokenID = CAD.getTokenId();
			try{
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			var url = CM.getAGPAPIUrl("AGP_VALIDATE_ORDER");
				var request = {
                    url: url,
                    header: {
                        "Content-Type": "application/json",
                        "Accept":"application/json"
                    },
                    data: getRequestBody(tokenId, tokenType),
                    onSuccess: callBackSuccess
                }

				cvsUtility.commonServiceCode(url,"validateOrder",VOM,request,callBackSuccess,NS);
			}
		var getRequestBody = function(tokenId, tokenType){
			var apikey = CAD.hasOwnProperty('getApiKey') && CAD.getApiKey() ? CAD.getApiKey() : cvsUtility.queryMap.apikey;
			var drugArray = [];
			var dList = ICM.getCartItems();
			for(var i =0; i< dList.length; i++){
				var obj = {"sourceSystem": dList[i].prescriptionSystemName,
							"rxNumber": dList[i].rxNumber,
							"rxNumberEnc": dList[i].rxNumberEnc,
							"drugNdc": dList[i].dispensedDrugNDC,
							"firstFillIndicator" : dList[i].firstFillIndicator
						}
				if (dList[i].suppliesGrouped) {
					var groupSupply = dList[i].suppliesGrouped;
					var supplyObj = [];
					for (var j = 0; j < groupSupply.length; j++) {
						(function (j) {
							var groupedObj = {
								"sourceSystem": groupSupply[j].prescriptionSystemName,
								"rxNumber": groupSupply[j].rxNumber,
								"rxNumberEnc": groupSupply[j].rxNumberEnc,
								"drugNdc": groupSupply[j].dispensedDrugNDC,
								"firstFillIndicator": groupSupply[j].firstFillIndicator,
							}
							drugArray.push(groupedObj);

						})(j);
					}
				}
					drugArray.push(obj);
				}

			var reqObj = {
                "validateOrderRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
							"responseFormat": "JSON",
							"tokenID" : tokenId,
							"tokenType": CM.getAGPTokenType(tokenType)

                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
					"details": {
						"orderInfo": {
							"rxInfos" : drugArray
						}
					}
                }
			};

			return reqObj;
			}

	}

	return new validateOrder();
}]);


